<template>
  <div class="sleepReport">
    <div class="search">
      <div class="box-left">
        <el-date-picker
          v-model="dateTime"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          placeholder="选择日期">
        </el-date-picker>
        <el-button type="primary" @click="handleInfo">查询</el-button>
      </div>
      <div class="box-right">
        <el-button type="primary" @click="handleJump">睡眠统计</el-button>
      </div>
    </div>
    <div class="echarts">
      <div class="earchs-left" style="margin-right: 15px;">
        <h3>睡眠时间统计</h3>
        <div class="imgEchart">
          <div class="min-left">
            <sleep-breathes :sleepData="sleepData"></sleep-breathes>
          </div>
          <div class="min-right">
            <div class="top">
              <div>
                <div>{{sleepData.timeToFallAsleep ? sleepData.timeToFallAsleep : '--' }}</div>
                <div>入睡时间</div>
              </div>
              <div>
                <div>{{sleepData.workUpTime ? sleepData.workUpTime : '--'}}</div>
                <div>醒来时间</div>
              </div>
              <div>
                <div class="time">
                  {{sleepData.effectiveSleepDuration ? sleepData.effectiveSleepDuration.slice(0, 2) : '00'}}<span>时</span>{{sleepData.effectiveSleepDuration ? sleepData.effectiveSleepDuration.slice(3, 5) : '00'}}<span>分</span>
                </div>
                <div>睡眠时长</div>
              </div>
            </div>
            <div class="top">
              <div>
                <div class="time">
                  {{sleepData.deepSleep == null ? '00' : sleepData.deepSleep.kindOfTime.slice(0, 2)}}<span>时</span>{{sleepData.deepSleep == null ? '00' : sleepData.deepSleep.kindOfTime.slice(3, 5)}}<span>分</span>
                </div>
                <div>深度睡眠</div>
              </div>
              <div>
                <div class="time">
                  {{sleepData.moderateSleep == null ? '00' : sleepData.moderateSleep.kindOfTime.slice(0, 2)}}<span>时</span>{{sleepData.moderateSleep == null ? '00' : sleepData.moderateSleep.kindOfTime.slice(3, 5)}}<span>分</span>
                </div>
                <div>中度睡眠</div>
              </div>
              <div>
                <div class="time">
                  {{sleepData.lightSleep == null ? '00' : sleepData.lightSleep.kindOfTime.slice(0, 2)}}<span>时</span>{{sleepData.lightSleep == null ? '00' : sleepData.lightSleep.kindOfTime.slice(3, 5)}}<span>分</span>
                </div>
                <div>浅度睡眠</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="earchs-left">
        <h3>睡眠分析</h3>
        <div class="analysis" v-if="sleepData.effectiveSleepDuration">
          你好，你昨晚入睡时间为{{sleepData.timeToFallAsleep}},有效睡眠时长为{{sleepData.effectiveSleepDuration}},睡眠效率为{{sleepData.sleepEfficiency}},睡眠评分为{{sleepData.score }}分，睡眠质量{{sleepData.sleepQuality }}，
          其中深睡时间为{{sleepData.deepSleep == null ? '00时00分' : sleepData.deepSleep.kindOfTime}}、睡眠时长<span :style="{color: sleepData.deepSleep == null ? '#FF474A' : sleepData.deepSleep.score == '偏低' ? '#FF474A' : sleepData.deepSleep.score == '偏高' ? '#FF474A' : ''}">{{sleepData.deepSleep == null ? '偏低' : sleepData.deepSleep.score}}</span>，
          中睡时间为{{sleepData.moderateSleep == null ? '00时00分' : sleepData.moderateSleep.kindOfTime}}、睡眠时长<span :style="{color: sleepData.moderateSleep == null ? '#FF474A' : sleepData.moderateSleep.score == '偏低' ? '#FF474A' : sleepData.moderateSleep.score == '偏高' ? '#FF474A' : ''}">{{sleepData.moderateSleep == null ? '偏低' : sleepData.moderateSleep.score}}</span>，
          浅睡时间为{{sleepData.lightSleep == null ? '00时00分' : sleepData.lightSleep.kindOfTime}}、睡眠时长<span :style="{color: sleepData.lightSleep == null ? '#FF474A' : sleepData.lightSleep.score == '偏低' ? '#FF474A' : sleepData.lightSleep.score == '偏高' ? '#FF474A' : ''}">{{sleepData.lightSleep == null ? '偏低' : sleepData.lightSleep.score}}</span>，
          清醒时间为{{sleepData.sober == null ? '00时00分' : sleepData.sober.kindOfTime}}、清醒时长<span :style="{color: sleepData.sober == null ? '#FF474A' : sleepData.sober.score == '偏低' ? '#FF474A' : sleepData.sober.score == '偏高' ? '#FF474A' : ''}">{{sleepData.sober == null ? '偏低' : sleepData.sober.score}}</span>，
          体动次数{{sleepData.bodyNumber}}次，清醒次数{{sleepData.soberNumber}}次，呼吸异常次数{{sleepData.breatheAbnormalNumber}}次。
          <div style="text-indent: 2em;">
            过度疲劳，容易出现上气道狭窄、软组织松弛，影响睡觉时的呼吸情况。建议：睡觉前两个小时吃少量的晚餐，
            不要喝太多的水，不要做剧烈运动；合理安排工作和学习，保持劳逸结合，避免过度疲劳；坚持有规律的作息时间
          </div>
        </div>
        <div class="analysis" v-else>
          睡眠时长较短数据无参考意义，请注意休息！
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sleepBreathes from "@/components/sleepMonitor/sleepBreathes"
export default {
  props: {
    deviceId: {
      type: Number,
      default: () => {
        return null;
      }
    },
    deviceImei: {
      type: [Number, String],
      default: () => {
        return null;
      }
    },
    type: {
      type: String,
      default: 'gas'
    }
  },
  components: {
    sleepBreathes
  },
  data() {
    return {
      dateTime: '',
      sleepData: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()- 3600 * 1000 * 24; // 今天之前禁用，减去一天的毫秒数，否则今天也将禁用
        }
      },
    }
  },
  created() {
    // 初始化获取时间
    let date = new Date(); // 获取当前时间戳
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    let day = date.getDate();
    day = day < 10 ? "0" + day : day;
    this.dateTime = year + "-" + month + "-" + day;
    this.handleInfo()

  },
  methods: {
    // 初始化获取数据
    handleInfo () {
      this.request.post('/front/device/sleep/mulSleepDay', {
        // deviceId: this.$route.query.deviceId,
        deviceId: this.deviceId,
        time: this.dateTime,
        isHome: 0
      }).then(res => {
        if (res.code == 200) {
          this.sleepData = res.data
        }
      })
    },
    // 点击跳转统计页面
    handleJump () {
      let id = this.deviceId
      this.$router.push({path: '/statistics', query: {id: id}})
    },
  }
};
</script>

<style lang="scss" scoped>
.sleepReport {
  // height: 100%;
  .search {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    .box-left {
      ::v-deep .el-date-editor {
        width: 135px;
        margin-right: 10px;
        .el-input__prefix {
          top: -4px !important;
        }
        .el-input__suffix {
          top: -4px !important;
        }
      }
      .el-button {
        padding: 0;
        height: 32px;
        width: 50px;
        background-color: #2177E6;
      }
    }
    .box-right {
      .el-button {
        padding: 0;
        height: 32px;
        width: 80px;
        background-color: #2177E6;
      }
    }
  }
  .echarts {
    margin-top: 20px;
    height: calc(100% - 50px);
    background-color: #F4F7FA;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    overflow-x: scroll;
    >div {
      width: 49.5%;
      height: 300px;
      min-width: 650px;
      border-radius: 10px;
      background-color: #fff;
      padding: 15px;
      box-sizing: border-box;
      >h3 {
        font-family: AlibabaPuHuiTi-Bold;
      }
      .imgEchart {
        display: flex;
        height: calc(100% - 22px);
        .min-left {
          width: 250px;
          height: 100%;
          background-color: #000;
        }
        .min-right {
          width: calc(100% - 250px);
          height: 100%;
          padding-top: 50px;
          box-sizing: border-box;
          .top {
            display: flex;
            justify-content: space-between;
            padding: 0 20px;
            box-sizing: border-box;
            margin-bottom: 30px;
            >div {
              text-align: center;
              div:nth-child(1) {
                color: #457CFF;
                font-size: 30px;
                font-family: AlibabaPuHuiTi-Bold;
              }
              div:nth-child(2) {
                font-size: 12px;
              }
              .time {
                >span {
                  color: #000;
                  font-size: 14px;
                  font-family: AlibabaPuHuiTi-Regular;
                }
              }
            }
          }
        }
      }
      .analysis {
        text-indent: 2em;
        margin-top: 30px;
        line-height: 32px;
        // text-decoration: #ff534c dashed underline;
      }
    }
  }
}
</style>